import { useEffect, useMemo } from "react";
import { AppContextProvider } from "@src/autoDebit/AppContext";
import { localeCreatorInput } from "@src/autoDebit/locale";
import { createContext } from "@src/context";
import Register from "../templates/Register";

const APP_NAME = "autoDebit";
const App = () => {
  const appContext = useMemo(
    () => createContext(APP_NAME, localeCreatorInput()),
    []
  );

  useEffect(() => {
    document.documentElement.lang = appContext.locale;
  }, [appContext]);

  return (
    <AppContextProvider appContext={appContext}>
      <Register></Register>
    </AppContextProvider>
  );
};

export default App;
